module.exports = __webpack_public_path__ + "static/media/footer-marker.2bb915c7.svg";